import { Legend } from '../../../types/common';

const items = [
  { name: 'Cvs Ptd', color: '#ff0000' },
  { name: 'CVS WILD', color: '#2167db' },
  { name: 'SINGLE', color: '#FFCC00' },
  { name: 'UNPROD', color: '#808080' },
  { name: 'I/A - INACCURATE' },
];

const template = `
  <div class="covey-legend">
    ${items
      .map(
        (item) => `
        <div class="covey-legend__breakdown">
          ${
            (item.color &&
              `<div class="covey-legend__bullet" style="background-color: ${item.color}"></div>`) ||
            ''
          }
          ${item.name}
        </div>
    `,
      )
      .join('')}
  </div>
`;

const breakdown = (): Legend => {
  const div = document.createElement('div');
  div.innerHTML = template;
  return div;
};

export default breakdown;
